import {
  IList,
  List,
  IListResult,
  ListResultDto,
  IPagedResult,
  PagedResultDto,
  Dictionary,
  IDictionary,
  IRequestOptions,
  IRequestConfig,
  getConfigs,
  axios,
  basePath
} from './index.defs';

export class FeatureFlagsService {
  /** Generate by swagger-axios-codegen */
  // @ts-nocheck
  /* eslint-disable */

  /**
   *
   */
  static isEnabled(
    params: {
      /**  */
      featureName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/FeatureFlags/IsEnabled';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { featureName: params['featureName'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }

    /**
   *
   */
  static getFeatureValue(
    params: {
      /**  */
      featureName?: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/FeatureFlags/GetFeatureValue';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { featureName: params['featureName'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}
